import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-imaac',
  templateUrl: './imaac.component.html',
  styleUrls: ['./imaac.component.scss']
})
export class ImaacComponent implements OnInit {

  exposition: CardContent = {
    title: 'IMAAC',
    subtitle: 'Using nanotechnology to fight mosquito-transmitted diseases',
    image_source: 'assets/images/IMAAC.png',
  };

  information: CardContent = {
    title: 'Project Info',
    sections: [
      '<h4>Cleints / Partners</h4>COST, Horizon 2020',
      '<h4>Methods</h4>Consulting, Web Development',
      '<h4>Technology / Skills</h4>Wordpress, Buddypress',
      '<h4>Term</h4>2017 - 2021',
    ]
  };

  constructor() { }

  ngOnInit(): void {
  }

}
